"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var moment = require("moment");

var DateParser_1 = require("../../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var NumberInRangeValidator_1 = require("../../../core/model/data-dictionary/validators/NumberInRangeValidator");

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * Represents partial snapshot of SelloutRelease. Currently it is used to store state of sellout release before reopening.
 * It contains only fields necessary for it, but if needed it could be extended and reused. This should be readonly, immutable entity.
 *
 * @author Jan Prokop
 */


var SelloutReleaseSnapshot =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutReleaseSnapshot, _DomainObject_1$Domai);

  /**
   * @param snapshotTime Time of creation of snapshot, this could be used as identifier. When creating
   *                     snapshots of multiple items, they should share the same time. This can keep consistency
   *                     if something fails and can be used for debugging.
   * @param priceValidityStartDate
   * @param endDate
   * @param minPriceChangeInPercent
   * @param maxPriceChangeInPercent
   * @param minMarginChangeInPercent
   * @param repricingEstimationThreshold
   */
  function SelloutReleaseSnapshot(snapshotTime, priceValidityStartDate, endDate, minPriceChangeInPercent, maxPriceChangeInPercent, minMarginChangeInPercent, repricingEstimationThreshold) {
    var _this;

    _classCallCheck(this, SelloutReleaseSnapshot);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseSnapshot).call(this));
    _this.snapshotTime = snapshotTime;
    _this.priceValidityStartDate = priceValidityStartDate;
    _this.endDate = endDate;
    _this.minPriceChangeInPercent = minPriceChangeInPercent;
    _this.maxPriceChangeInPercent = maxPriceChangeInPercent;
    _this.minMarginChangeInPercent = minMarginChangeInPercent;
    _this.repricingEstimationThreshold = repricingEstimationThreshold;
    return _this;
  }
  /**
   * Creates snapshot from sellout release.
   */


  _createClass(SelloutReleaseSnapshot, null, [{
    key: "createFromRelease",
    value: function createFromRelease(item) {
      var snapshotTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : moment();
      return new SelloutReleaseSnapshot(snapshotTime, item.priceValidityStartDate, item.endDate, item.minPriceChangeInPercent, item.maxPriceChangeInPercent, item.minMarginChangeInPercent, item.repricingEstimationThreshold);
    }
    /**
     * Converter from data-dictionary representation
     */

  }, {
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new SelloutReleaseSnapshot(mat.snapshotTime, mat.priceValidityStartDate, mat.endDate, mat.minPriceChangeInPercent, mat.maxPriceChangeInPercent, mat.minMarginChangeInPercent, mat.repricingEstimationThreshold);
    }
  }]);

  return SelloutReleaseSnapshot;
}(DomainObject_1.DomainObject);

exports.SelloutReleaseSnapshot = SelloutReleaseSnapshot;

SelloutReleaseSnapshot.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutReleaseSnapshot.name);
  return {
    snapshotTime: builder.date('snapshotTime', DateParser_1.DateParser.ISO_PATTERN),
    priceValidityStartDate: builder.opt(builder.date('priceValidityStartDate', DateParser_1.DateParser.ISO_PATTERN)),
    endDate: builder.opt(builder.date('endDate', DateParser_1.DateParser.ISO_PATTERN)),
    minPriceChangeInPercent: builder.opt(builder.bigNum('minPriceChangeInPercent')),
    maxPriceChangeInPercent: builder.opt(builder.bigNum('maxPriceChangeInPercent')),
    minMarginChangeInPercent: builder.opt(builder.bigNum('minMarginChangeInPercent')),
    repricingEstimationThreshold: builder.opt(builder.num('repricingEstimationThreshold', new NumberInRangeValidator_1.NumberInRangeValidator(0, 100)))
  };
}();